import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { T } from './UI';

const when = (d) => new Date(d).toLocaleString('en-AU', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' });

// Induction column for a staff member: send it, track it, then a green circle once signed off
export default function EmployeeInduction({ employee, onChanged, onNotice }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const ind = employee.induction;

  const run = async (request, success) => {
    setBusy(true); onNotice?.(null);
    try {
      await request();
      onNotice?.({ type:'success', text: success });
      onChanged?.();
    } catch (err) {
      onNotice?.({ type:'error', text: err.response?.data?.message || 'Something went wrong. Please try again.' });
    } finally { setBusy(false); }
  };

  const send = () => {
    if (!window.confirm(`Email the induction login to ${employee.fullName} at ${employee.email}?`)) return;
    run(() => api.post(`/employees/${employee._id}/send-induction`), `Induction login emailed to ${employee.email}. It's valid for 24 hours.`);
  };

  const resend = () => {
    if (!window.confirm(`Send ${employee.fullName} a new login at ${employee.email}? Their previous login will stop working.`)) return;
    run(() => api.post(`/staff-inductions/${ind._id}/resend`), `A new login was emailed to ${employee.email}. It's valid for 24 hours.`);
  };

  // Same download as the Staff Induction list — available once the worker has submitted the filled form
  const download = () => {
    const token   = localStorage.getItem('cs_token');
    const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
    window.open(`${baseURL}/api/staff-inductions/${ind._id}/pdf?token=${token}`, '_blank');
  };
  const downloadBtn = (
    <button onClick={download} title="Download the filled induction form (PDF)" style={{ ...T.btnIcon, color:'var(--blue)', borderColor:'rgba(10,110,180,0.25)' }}>
      <i className="ti ti-file-download" style={{ fontSize:'13px' }} aria-label="Download the filled induction form (PDF)"/>
    </button>
  );

  if (!ind) {
    return (
      <button onClick={send} disabled={busy} style={{ ...T.btnPrimary, padding:'6px 12px', fontSize:'12px', opacity:busy?0.6:1 }}>
        <i className="ti ti-send" aria-hidden="true"/> {busy ? 'Sending...' : 'Send induction'}
      </button>
    );
  }

  if (ind.status === 'completed') {
    return (
      <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
        <button onClick={()=>navigate(`/staff-induction/${ind._id}`)} title="View the completed induction"
          style={{ display:'inline-flex', alignItems:'center', gap:'8px', background:'none', border:'none', padding:0, cursor:'pointer', fontFamily:'inherit' }}>
          <span style={{ width:'22px', height:'22px', borderRadius:'50%', background:'var(--green)', display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <i className="ti ti-check" style={{ fontSize:'14px', color:'#fff' }} aria-hidden="true"/>
          </span>
          <span style={{ fontSize:'12px', fontWeight:'500', color:'var(--green)', whiteSpace:'nowrap' }}>Induction completed</span>
        </button>
        {downloadBtn}
      </div>
    );
  }

  if (ind.status === 'awaiting_supervisor') {
    return (
      <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
        <button onClick={()=>navigate(`/staff-induction/${ind._id}/edit`)} title="Review and sign off"
          style={{ ...T.btnPrimary, padding:'6px 12px', fontSize:'12px' }}>
          <i className="ti ti-writing" aria-hidden="true"/> Awaiting sign-off
        </button>
        {downloadBtn}
      </div>
    );
  }

  // invited — the worker hasn't submitted yet
  const expired = ind.tempExpiresAt && new Date(ind.tempExpiresAt) <= new Date();
  return (
    <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
      <div>
        <span style={{ background: expired ? 'var(--red-bg)' : 'var(--amber-bg)', color: expired ? 'var(--red)' : 'var(--amber)', fontSize:'11px', fontWeight:'500', padding:'2px 9px', borderRadius:'20px', whiteSpace:'nowrap' }}>
          {expired ? 'Login expired' : 'Sent'}
        </span>
        {!expired && ind.tempExpiresAt && <div style={{ fontSize:'10px', color:'var(--muted)', marginTop:'3px', whiteSpace:'nowrap' }}>Expires {when(ind.tempExpiresAt)}</div>}
      </div>
      <button onClick={resend} disabled={busy} title="Send a new login" style={{ ...T.btnIcon, color:'var(--purple)', borderColor:'rgba(83,74,183,0.25)', opacity:busy?0.5:1 }}>
        <i className="ti ti-send" style={{ fontSize:'13px' }} aria-label="Send a new login"/>
      </button>
    </div>
  );
}
